/**
 * PageDomaines — PEFEP TECH
 * ---------------------------------------------------------------
 * Page publique dediee a la recherche de nom de domaine.
 * Le contenu editorial est visible de tous (interet SEO) ;
 * seule la recherche exige un compte connecte.
 */

import React from 'react';
import SEO from './composants/SEO';
import { SEO_PAGES } from './donnees/seoPages';
import RechercheDomaine from './composants/RechercheDomaine';
import './PageDomaines.css';
import Navigation from './composants/Navigation';
import PiedDePage from './composants/PiedDePage';

function PageDomaines() {
  return (
    <div className="pd-page">
      <SEO {...SEO_PAGES.domaines} />
      <Navigation />

      <section className="pd-entete">
        <span className="pd-etiquette">🌐 Nom de domaine</span>
        <h1>Votre adresse web professionnelle</h1>
        <p>
          Une adresse à votre nom inspire confiance et vous rend trouvable.
          Verifiez la disponibilite du votre et decouvrez nos tarifs reels,
          sans frais caches.
        </p>
      </section>

      <section className="pd-recherche">
        <RechercheDomaine
          titre="Verifiez la disponibilite"
          sousTitre="Tapez le nom de votre entreprise, sans extension."
        />
      </section>

      <section className="pd-explications">
        <h2>Pourquoi un nom de domaine change tout</h2>

        <div className="pd-colonnes">
          <article className="pd-bloc-texte">
            <h3>Credibilite immediate</h3>
            <p>
              Une adresse en <strong>votreentreprise.com</strong> et une adresse
              e-mail assortie transforment la perception de votre organisation.
              Vos clients vous prennent au serieux avant meme d'avoir lu votre
              page d'accueil.
            </p>
          </article>

          <article className="pd-bloc-texte">
            <h3>Visibilite sur Google</h3>
            <p>
              Un domaine propre, stable et coherent avec votre activite aide les
              moteurs de recherche à identifier votre entreprise et à la relier
              à vos profils professionnels.
            </p>
          </article>

          <article className="pd-bloc-texte">
            <h3>Un actif qui vous appartient</h3>
            <p>
              Votre domaine vous suit partout : changement d'hebergeur, refonte
              du site, nouvelle plateforme. C'est votre adresse permanente sur
              Internet, et elle vous appartient.
            </p>
          </article>
        </div>
      </section>

      <section className="pd-transparence">
        <h2>Des tarifs affiches sans detour</h2>
        <p>
          La plupart des vendeurs de domaines cassent le prix la premiere annee
          puis augmentent fortement au renouvellement. Nous affichons
          <strong> les deux prix des la recherche</strong> : ce que vous payez
          aujourd'hui, et ce que vous paierez chaque annee ensuite. Aucune
          mauvaise surprise.
        </p>
        <p className="pd-note">
          Le <strong>.ht</strong> passe par le registre haitien et demande une
          verification manuelle. Nous vous confirmons sa disponibilite sous
          24 heures ouvrables.
        </p>
      </section>
      <PiedDePage />
    </div>
  );
}

export default PageDomaines;